import React from 'react';

interface MockupFlowSummaryProps {
  title: string;
  description: string;
  items: Array<{
    label: string;
    value: string;
    tone?: 'default' | 'success' | 'warning';
  }>;
}

const toneClasses: Record<NonNullable<MockupFlowSummaryProps['items'][number]['tone']>, string> = {
  default: 'border-gray-200 bg-white text-gray-900',
  success: 'border-green-200 bg-green-50 text-green-900',
  warning: 'border-amber-200 bg-amber-50 text-amber-900',
};

const MockupFlowSummary: React.FC<MockupFlowSummaryProps> = ({ title, description, items }) => {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
      <div className="mb-5">
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        <p className="mt-1 text-sm text-gray-600">{description}</p>
      </div>

      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
        {items.map((item) => (
          <div
            key={item.label}
            className={`rounded-xl border px-4 py-3 ${toneClasses[item.tone || 'default']}`}
          >
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">{item.label}</p>
            <p className="mt-2 text-sm font-semibold">{item.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MockupFlowSummary;
